<template>
  <el-container class="AProductForm">
    <el-main class="p-0">
      <el-form
        ref="form"
        label-width="70px"
        class="form-label-70"
        :model="data"
        :rules="rules"
      > 
        <el-col :span="24">
          <el-form-item label="품목" prop="product_id">
            <AProductSelector
              v-model="data.product_name"
              @select="handleSelectProduct"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="규격" prop="size">
            <el-input v-model="data.size" />          
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="수량" prop="amount">
            <ANumberInput  
              v-model="data.amount" 
              allowDecimal
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="단위" prop="unit_id">
            <AProductUnitSelector  
              v-model="data.unit_id" 
              :id="data.product_id"
            />
          </el-form-item>
        </el-col>
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        @click="handleClickRegister"
      >{{isNew ? $t('button.register') : $t('button.modify') }}</el-button>
      <el-button
        @click="handleClickCancel"
      >{{$t('button.cancel')}}</el-button>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: "AProductForm",
  data() {
    return {
      rules: {
        product_id: [{ required: true, message: "품목을 선택해 주세요." }],
        amount: [{ required: true, message: "수량을 입력해 주세요." }],
      },
    }
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          id: 0,
          product_id: null,
          product_name: "",
          size: "",
          amount: 1,
          unit_id: 1,
        }
      },
    }
  },
  computed: {
    isNew: function() {
      return this.data.id < 1;
    },
  },
  methods: {
    handleSelectProduct(p) {
      if (typeof(p) === 'object') {                
        this.data.product_id = p.id;
        this.data.product_name = p.name;
        this.data.size = p.size;
      } else {
        if (p === "") {
          this.data.product_id = null;
          this.data.product_name = "";
          this.data.size = "";
        } else {
          this.data.product_id = null;
          this.data.product_name = p;
        }
      }
    },
    handleClickRegister() {
      this.$refs.form.validate(valid => {
        if (!valid) { return; }
        this.$emit('completed', this.data);
      });
    },
    handleClickCancel() {
      this.$emit('completed');
    },
  },
}
</script>